import {
  Pagination
} from 'react-bootstrap';
import React from 'react';
import PropTypes from 'prop-types';

class PagingControls extends React.Component {  
  renderPages() {
    let {
      currentPageNumber,
      disabled,
      totalNumberOfPages,
    } = this.props;
    
    let pageArray = [];
    if (totalNumberOfPages < 7) {
      for (let i = 1; i <= totalNumberOfPages; i++) {
        pageArray.push(this.renderPage(i));
      }
      return pageArray;
    }
    
    pageArray.push(this.renderPage(1));
    
    pageArray.push(...this.renderPagesBehind());
    
    if (currentPageNumber !== 1 && currentPageNumber !== totalNumberOfPages) {
      pageArray.push(this.renderPage(currentPageNumber));
    }
    
    pageArray.push(...this.renderPagesAhead());
    
    pageArray.push(this.renderPage(totalNumberOfPages));
    
    return pageArray;
  }
  
  renderPagesBehind() {
    let {
      currentPageNumber,
      disabled,
      totalNumberOfPages,
    } = this.props;
    let pages = [];
    
    let pagesBehind;
    if (currentPageNumber === 1) {
      pagesBehind = 0;
    } else if (currentPageNumber <= 4) {
      pagesBehind = currentPageNumber - 2;
    } else if (totalNumberOfPages - currentPageNumber <= 3) {
      pagesBehind = 4 - (totalNumberOfPages - currentPageNumber);
    } else {
      pagesBehind = 1;
    }
    
    if (currentPageNumber - pagesBehind > 2) {
      pages.push(
        <Pagination.Ellipsis
          className="ellipsis" 
          disabled={disabled}
          key={'behindEllipsis'} 
        />
      );
    }
    
    for (let i = currentPageNumber - pagesBehind; i < currentPageNumber; i++) {
      pages.push(this.renderPage(i));
    }
    
    return pages;
  }
  
  renderPagesAhead() {
    let {
      currentPageNumber,
      disabled,
      totalNumberOfPages,
    } = this.props;    
    let pages = [];
    
    let pagesAhead;
    
    if (currentPageNumber <= 4) {
      pagesAhead = 5 - currentPageNumber;
    } else if (totalNumberOfPages - currentPageNumber <= 3) {
      pagesAhead = totalNumberOfPages - currentPageNumber - 1;
    } else if (currentPageNumber === totalNumberOfPages) {
      pagesAhead = 0;
    } else {
      pagesAhead = 1;
    }
    
    for (let i = currentPageNumber + 1; i < currentPageNumber + pagesAhead + 1; i++) {
      pages.push(this.renderPage(i));
    }
    
    if (currentPageNumber + pagesAhead < totalNumberOfPages - 1) {
      pages.push(
        <Pagination.Ellipsis 
          className="ellipsis" 
          disabled={disabled} 
          key={'aheadEllipsis'} 
        />
      );
    }
    
    return pages;
  }
  
  renderPage(pageNumber) {
    let { 
      currentPageNumber,
      disabled, 
      loadPage 
    } = this.props;
    
    let isActivePage = pageNumber === currentPageNumber;
    return (
      <Pagination.Item
        active={isActivePage}
        disabled={disabled}
        key={pageNumber}
        onClick={isActivePage || disabled ? null : () => loadPage(pageNumber)}
      >
        {pageNumber}
      </Pagination.Item>
    );
  }
  
  render() {
    let {
      currentPageNumber,
      disabled,
      loadPage,
      totalNumberOfPages,
    } = this.props;

    let prev = currentPageNumber === 1 || disabled ? null : () => loadPage(currentPageNumber - 1);
    let next = currentPageNumber === totalNumberOfPages || disabled ? null : () => loadPage(currentPageNumber + 1);

    return (
      <Pagination>
        <Pagination.Prev
          disabled={!prev}
          onClick={prev}
        >
          ❮
        </Pagination.Prev>
        {this.renderPages()}
        <Pagination.Next 
          disabled={!next}
          onClick={next}
        >
          ❯
        </Pagination.Next >
      </Pagination>	
    );
  }
}

PagingControls.propTypes = {
  currentPageNumber: PropTypes.number,
  disabled: PropTypes.bool,
  loadPage: PropTypes.func,
  totalNumberOfPages: PropTypes.number,
};

export default PagingControls;
